// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tooltip-container {
  position: absolute;
  width: 300px;
  text-align: center;
  height: 55px;
  top: -48px;
}

.audio-slider-tooltip {
  width: 300px;
  text-align: center;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  background-color: white;
  color: rgb(36, 53, 71);
  border: solid 1px rgb(36, 53, 71);
  border-radius: 3px;
  box-shadow: 0px 0px 2px 0px rgb(36, 53, 71);
  padding: 0;
  height: 48px;
}`, "",{"version":3,"sources":["webpack://./src/Components/AudioSliderTooltip/AudioSliderTooltip.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,iCAAiC;EACjC,kBAAkB;EAClB,2CAA2C;EAC3C,UAAU;EACV,YAAY;AACd","sourcesContent":[".tooltip-container {\n  position: absolute;\n  width: 300px;\n  text-align: center;\n  height: 55px;\n  top: -48px;\n}\n\n.audio-slider-tooltip {\n  width: 300px;\n  text-align: center;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n  background-color: white;\n  color: rgb(36, 53, 71);\n  border: solid 1px rgb(36, 53, 71);\n  border-radius: 3px;\n  box-shadow: 0px 0px 2px 0px rgb(36, 53, 71);\n  padding: 0;\n  height: 48px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
